export type DeliveryDayFilterMode = 'atLeast' | 'exact';

/**
 * Single source of truth for the delivery-day filter, shared by the saved-zones
 * list (state/zipcode sortAndFilter) and the map highlight (zipcodes-map
 * filterSavedFilter) so the two surfaces can never disagree.
 *
 * - 'atLeast': the zip delivers on every selected day, and may deliver on more.
 *   (The original behavior: a 7-day zip matches an M/W/F selection.)
 * - 'exact': the zip's delivery days are exactly the selected days — no more,
 *   no fewer. (A 7-day zip only matches when all 7 days are selected.)
 *
 * An empty selection matches everything in both modes.
 */
export const matchesDeliveryDayFilter = (
  zipDays: number[] | undefined,
  selectedDays: number[],
  mode: DeliveryDayFilterMode,
): boolean => {
  if (selectedDays.length === 0) return true;
  const days = new Set(zipDays ?? []);
  const hasAllSelected = selectedDays.every((day) => days.has(day));
  if (mode === 'exact') {
    return hasAllSelected && days.size === selectedDays.length;
  }
  return hasAllSelected;
};
